import React from 'react'

import { IToggleStatus, PriceContext } from './PriceContext'

export function PriceContextProvider({
  toggleStatus,
  children,
}: {
  toggleStatus: IToggleStatus
  children: React.ReactNode
}) {
  const context: IToggleStatus = toggleStatus

  return (
    <PriceContext.Provider value={context}>{children}</PriceContext.Provider>
  )
}
